// Republic Atlas - Toast Notifications
// =====================================
// Using react-hot-toast for beautiful notifications

import { Toaster as HotToaster, toast } from 'react-hot-toast';

/**
 * Toast notification container
 * Place this at the root of your app (e.g., in App.tsx)
 */
export function Toaster() {
  return (
    <HotToaster
      position="top-right"
      gutter={12}
      containerStyle={{
        top: 80, // Account for header
      }}
      toastOptions={{
        // Default options for all toasts
        duration: 4000,
        style: {
          background: '#1e293b',
          color: '#f8fafc',
          padding: '14px 18px',
          borderRadius: '10px',
          fontSize: '14px',
          fontWeight: 500,
          boxShadow: '0 10px 40px rgba(0, 0, 0, 0.3)',
          border: '1px solid rgba(255, 255, 255, 0.1)',
        },
        // Success toast
        success: {
          iconTheme: {
            primary: '#10b981',
            secondary: '#d1fae5',
          },
          style: {
            background: '#022c22',
            borderColor: 'rgba(16, 185, 129, 0.3)',
          },
        },
        // Error toast
        error: {
          iconTheme: {
            primary: '#ef4444',
            secondary: '#fee2e2',
          },
          style: {
            background: '#2a1515',
            borderColor: 'rgba(239, 68, 68, 0.3)',
          },
        },
      }}
    />
  );
}

/**
 * Toast helper functions
 * Usage:
 *   showToast.success('Saved successfully!')
 *   showToast.error('Something went wrong')
 *   showToast.info('New updates available')
 *   showToast.promise(fetchData(), { loading: '...', success: '...', error: '...' })
 */
export const showToast = {
  success: (message: string) => toast.success(message),
  error: (message: string) => toast.error(message),
  info: (message: string) => toast(message, {
    icon: 'ℹ️',
    style: {
      background: '#1e3a5f',
      borderColor: 'rgba(59, 130, 246, 0.3)',
    },
  }),
  warning: (message: string) => toast(message, {
    icon: '⚠️',
    style: {
      background: '#422006',
      borderColor: 'rgba(245, 158, 11, 0.3)',
    },
  }),
  loading: (message: string) => toast.loading(message),
  dismiss: (toastId?: string) => toast.dismiss(toastId),
  promise: <T,>(
    promise: Promise<T>,
    messages: {
      loading: string;
      success: string;
      error: string;
    }
  ) => toast.promise(promise, messages),
  custom: toast,
};

export { toast };
export default Toaster;

